import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { useResponsive } from '@fabric-app/ui/hooks/useResponsive';
import { useQueryResourceMemberPermissions } from '../../../permission/queries/useQueryResourceMemberPermissions.js';
import MemberBar from './MemberBar.js';
import useMultiplayerFollow from '../../hooks/useMultiplayerFollow.js';
import { AnimatePresence } from 'framer-motion';
import { ButtonShare } from '../../../permission/components/ButtonShare.js';

const MemberBarSpaceOrFolderWithLiveBlocksBase = ({ resourceId, onOpenShareModal, type, renderShareButtonOutside, isPublicShared }) => {
  const { following, liveMembers, anonId, followUser, spotlightSelf } = useMultiplayerFollow(resourceId, type);
  const { membersWithRole, isLoading } = useQueryResourceMemberPermissions({
    resourceId
  });
  const hasMultipleMembers = membersWithRole.length > 1 || liveMembers.length + membersWithRole.length > 2;
  const { isMobileView } = useResponsive();
  const shouldRenderShareButtonOutside = renderShareButtonOutside && (!isMobileView || !hasMultipleMembers);
  return /* @__PURE__ */ jsx(AnimatePresence, {
    children: isLoading ? null : /* @__PURE__ */ jsxs(Fragment, {
      children: [
        /* @__PURE__ */ jsx(MemberBar, {
          members: membersWithRole,
          liveMembers,
          followUser,
          following,
          anonId,
          spotlightSelf,
          hideWhenAlone: true,
          maxMembers: isMobileView ? 1 : 3,
          onClickOpenSharingSettings: renderShareButtonOutside ? void 0 : onOpenShareModal,
          resourceId,
          itemType: type,
          isPublicShared
        }, "member-bar"),
        shouldRenderShareButtonOutside && onOpenShareModal && /* @__PURE__ */ jsx(ButtonShare, {
          onClick: onOpenShareModal
        }, "member-share-button")
      ]
    })
  });
};

export { MemberBarSpaceOrFolderWithLiveBlocksBase };
//# sourceMappingURL=MemberBarSpaceOrFolderWithLiveBlocksBase.js.map
